import { render, staticRenderFns } from "./journal-list.vue?vue&type=template&id=04f455eb"
import script from "./journal-list.vue?vue&type=script&lang=js"
export * from "./journal-list.vue?vue&type=script&lang=js"
import style0 from "./journal-list.vue?vue&type=style&index=0&id=04f455eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports